<template>
  <div>
    <v-text-field
      :value="value.title"
      label="Section Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <image-uploader
      :value="value.backgroundImage"
      label="Section Background Image"
      @input="update('backgroundImage', $event)"
    />
    <v-slider
      v-if="value.backgroundImage"
      :value="value.bgOpacity !== undefined ? value.bgOpacity : 85"
      label="Background Darken %"
      min="0"
      max="100"
      thumb-label
      dense
      @input="update('bgOpacity', $event)"
    ></v-slider>
    <div class="mb-2 font-weight-medium">Testimonials</div>
    <v-card v-for="(item, i) in items" :key="i" outlined class="mb-2 pa-3">
      <v-textarea
        :value="item.quote"
        label="Quote"
        outlined
        dense
        rows="2"
        @input="updateItem(i, 'quote', $event)"
      />
      <image-uploader
        :value="item.image"
        label="Author Image"
        @input="updateItem(i, 'image', $event)"
      />
      <v-row dense>
        <v-col cols="5">
          <v-text-field
            :value="item.author"
            label="Author"
            outlined
            dense
            @input="updateItem(i, 'author', $event)"
          />
        </v-col>
        <v-col cols="5">
          <v-text-field
            :value="item.role"
            label="Role"
            outlined
            dense
            @input="updateItem(i, 'role', $event)"
          />
        </v-col>
        <v-col cols="2" class="d-flex align-center">
          <v-btn icon small color="error" @click="removeItem(i)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-btn text small color="primary" @click="addItem">
      <v-icon small left>mdi-plus</v-icon>Add Testimonial
    </v-btn>
  </div>
</template>

<script>
import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  computed: {
    items() {
      return this.value.items || [];
    },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    addItem() {
      if (this.items.length > 0) {
        const lastItem = this.items[this.items.length - 1];
        if (!lastItem.author || lastItem.author.trim() === "") {
          this.$swal ? this.$swal("Validation Error", "Please fill the author of the last testimonial before adding a new one.", "error") : alert("Please fill the author of the last testimonial before adding a new one.");
          return;
        }
      }
      this.$emit("input", {
        ...this.value,
        items: [...this.items, { quote: "", author: "", role: "" }],
      });
    },
    removeItem(i) {
      this.$emit("input", {
        ...this.value,
        items: this.items.filter((_, idx) => idx !== i),
      });
    },
    updateItem(i, key, val) {
      var items = this.items.map((item, idx) =>
        idx === i ? { ...item, [key]: val } : item
      );
      this.$emit("input", { ...this.value, items });
    },
  },
};
</script>
